export default __webpack_public_path__ + "static/media/rafiki.b881cd21.png";